import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-four-image-with-text',
  templateUrl: './four-image-with-text.component.html',
  styleUrls: ['./four-image-with-text.component.css']
})
export class FourImageWithTextComponent {
  @Input() data!:any;
}
